import { render, staticRenderFns } from "./JobMappingPage.vue?vue&type=template&id=05af8a4a"
import script from "./JobMappingPage.vue?vue&type=script&lang=js"
export * from "./JobMappingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports